import React from "react";
import { Card, Avatar, Button } from "antd";
import { TeamOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import "./ReportsToWidget.css";

const defaultSupervisor = {
  name: "Michael Chen",
  pin: "EMP-2019-0015",
  designation: "Engineering Manager",
  email: "michael.chen@company.com",
  phone: "+1 (555) 123-4567",
  imageUrl: "",
};

export function ReportsToWidget({ reportsToData }) {
  const supervisor = reportsToData?.[0] || defaultSupervisor;
  const initials = supervisor.name
    ? supervisor.name
        .split(" ")
        .map((n) => n[0])
        .join("")
    : "";

  const handleEmail = () => {
    if (supervisor.email) {
      window.location.href = `mailto:${supervisor.email}`;
    }
  };

  const handleCall = () => {
    if (supervisor.phone) {
      window.location.href = `tel:${supervisor.phone.replace(/\D/g, "")}`;
    }
  };

  return (
    <div className="reports-to-widget">
      <div className="reports-to-widget__card" bordered={false}>
        <div className="reports-to-widget__body">
          <Avatar
            size={80}
            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${supervisor.imageurl}${process.env.REACT_APP_IMAGE_TOKEN_KEY}`}
            className="reports-to-widget__avatar"
          >
            {!supervisor.imageUrl ? initials : null}
          </Avatar>
          <h3 className="reports-to-widget__name">{supervisor.name}</h3>
          <p className="reports-to-widget__designation">
            {supervisor.designation}
          </p>
          <p className="reports-to-widget__pin">{supervisor.pin}</p>
          <div className="reports-to-widget__actions">
            <Button
              type="default"
              icon={<MailOutlined />}
              onClick={handleEmail}
              className="reports-to-widget__btn"
            >
              Email
            </Button>
            <Button
              type="default"
              icon={<PhoneOutlined />}
              onClick={handleCall}
              className="reports-to-widget__btn"
            >
              Call
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
